<template>
  <div class="card card-custom">
    <div class="card-body p-0">
      <!--begin: Wizard-->
      <div
        class="wizard wizard-2"
        id="kt_wizard_v2"
        data-wizard-state="step-first"
        data-wizard-clickable="true"
      >
        <!--begin: Wizard Nav -->
        <div class="wizard-nav border-right py-8 px-8 py-lg-20 px-lg-10">
          <div class="wizard-steps">
            <div
              class="wizard-step"
              data-wizard-type="step"
              data-wizard-state="current"
              @click="nextStep(1)"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg
                      src="/media/svg/icons/General/Shield-protected.svg"
                    />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    {{ $t('detail.stash.stashInformation') }}
                  </h3>
                  <div class="wizard-desc">
                    {{ $t('detail.stash.setupYourStash') }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="wizard-step"
              data-wizard-type="step"
              @click="nextStep(2)"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="/media/svg/icons/General/User.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    {{ $t('detail.stash.userInformation') }}
                  </h3>
                  <div class="wizard-desc">
                    {{ $t('detail.stash.setupYourUser') }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="wizard-step"
              data-wizard-type="step"
              @click="nextStep(3)"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="/media/svg/icons/Map/Compass.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    {{ $t('detail.stash.setupPackage') }}
                  </h3>
                  <div class="wizard-desc">
                    {{ $t('detail.stash.chooseYourPackage') }}
                  </div>
                </div>
              </div>
            </div>
            <div
              class="wizard-step"
              data-wizard-type="step"
              @click="nextStep(4)"
            >
              <div class="wizard-wrapper">
                <div class="wizard-icon">
                  <span class="svg-icon svg-icon-2x">
                    <inline-svg src="/media/svg/icons/General/Like.svg" />
                  </span>
                </div>
                <div class="wizard-label">
                  <h3 class="wizard-title">
                    {{ $t('detail.stash.confirmation') }}
                  </h3>
                  <div class="wizard-desc">
                    {{ $t('detail.stash.checkoutYourOrderAndConfirm') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end: Wizard Nav -->

        <!--begin: Wizard Body -->
        <div class="wizard-body py-8 px-8 py-lg-20 px-lg-10">
          <!--begin: Wizard Form-->
          <div class="row">
            <div class="offset-xxl-2 col-xxl-8">
              <form class="form" id="kt_form">
                <!--begin: Wizard Step 1-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-5 font-weight-bold text-dark">
                    {{ $t('detail.stash.setupYourStash') }}
                  </h4>

                  <p class="mb-10">
                    {{ $t('detail.stash.setupYourStashInfo') }}
                  </p>

                  <Input
                    label="detail.stash.stashName"
                    v-model="step1.stashName"
                    :state="validateStep1('stashName')"
                    :errorMessage="validateStashName"
                  />

                  <Textarea
                    label="detail.stash.stashDescription"
                    v-model="step1.stashDescription"
                    :state="validateStep1('stashDescription')"
                    :errorMessage="validateStashDescription"
                  />
                </div>
                <!--end: Wizard Step 1-->

                <!--begin: Wizard Step 2-->
                <div
                  class="pb-5"
                  data-wizard-type="step-content"
                  data-wizard-state="current"
                >
                  <h4 class="mb-5 font-weight-bold text-dark">
                    {{ $t('detail.stash.setupYourUser') }}
                  </h4>

                  <p class="mb-10">
                    {{ $t('detail.stash.setupYourUserInfo') }}
                  </p>

                  <Input
                    label="detail.stash.username"
                    v-model="step2.username"
                    :state="stateUsername"
                    :errorMessage="validateUsername"
                    disableSpecialCharacters="true"
                  />
                  <Input
                    label="global.password"
                    v-model="step2.password"
                    :state="validateStep2('password')"
                    :errorMessage="validatePassword"
                    type="password"
                  />
                </div>
                <!--end: Wizard Step 2-->

                <!--begin: Wizard Step 3-->
                <div class="pb-5" data-wizard-type="step-content">
                  <h4 class="mb-10 font-weight-bold text-dark">
                    {{ $t('detail.stash.chooseYourPackage') }}
                  </h4>

                  <div
                    class="d-flex align-items-center mb-10"
                    v-if="catalogList && catalogList.length > 0"
                    v-for="catalog in catalogList"
                    :key="`${catalog.id}`"
                  >
                    <b-form-radio
                      v-model="step3.productCatalogId"
                      type="radio"
                      :value="`${catalog.id}`"
                      size="lg"
                    >
                    </b-form-radio>
                    <!--begin::Item-->
                    <div class="d-flex flex-wrap">
                      <!--begin::Symbol-->
                      <div class="symbol symbol-50 symbol-light mr-5">
                        <span class="symbol-label">
                          <img
                            src="/media/stash/stash_icon.png"
                            class="h-100 align-self-center rounded-sm"
                            :alt="catalog.name"
                          />
                        </span>
                      </div>
                      <!--end::Symbol-->

                      <!--begin::Text-->
                      <div class="d-flex flex-column flex-grow-1 mr-2">
                        <p
                          class="font-weight-bold text-dark-75 text-hover-primary font-size-lg mb-1"
                          v-html="catalog.name"
                        ></p>
                        <span class="text-muted font-weight-bold">{{
                          $t('time.' + catalog.subscription_type)
                        }}</span>
                      </div>
                      <!--end::Text-->
                      <span
                        class="label label-xl label-light label-inline my-lg-0 my-2 text-dark-50 font-weight-bolder ml-auto"
                        >{{ $customFunctions.moneyFix(catalog.price, 2) }}
                        {{ catalog.currency_code }}</span
                      >
                    </div>
                    <!--end::Item-->
                  </div>
                  <Input
                    label="giftcode.giftcode"
                    v-model="step3.gift_code"
                    class="mb-0"
                    :state="codeIsValid"
                  />
                  <b-skeleton-wrapper :loading="loadingGiftCode">
                    <template #loading>
                      <b-card>
                        <b-skeleton width="85%"></b-skeleton>
                        <b-skeleton width="55%"></b-skeleton>
                        <b-skeleton width="70%"></b-skeleton>
                      </b-card>
                    </template>
                    <a
                      href="javascript:;"
                      class="select-from-link"
                      @click="checkEnteredCode"
                      v-if="checkCode === ''"
                      >{{ $t('giftcode.checkCode') }}
                    </a>

                    <a
                      href="javascript:;"
                      class="select-from-link"
                      @click="removeCode"
                      v-else
                      >{{ $t('giftcode.cancelCode') }}
                    </a>

                    <InfoBox
                      v-if="checkCode && checkCode.is_used"
                      class="mt-3"
                      >{{ $t('giftcode.codeUsedBefore') }}</InfoBox
                    >

                    <div
                      class="product-catalog-total-info justify-content-start mt-3"
                      v-if="checkCode && codeIsValid"
                    >
                      <div
                        class="product-catalog-total-info-content w-100 mw-100"
                      >
                        <div class="item">
                          <div class="name">{{ $t('giftcode.product') }}:</div>
                          <div class="result">
                            <div>
                              {{
                                checkCode.productCatalog &&
                                checkCode.productCatalog.data
                                  ? checkCode.productCatalog.data.name
                                  : '-'
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="item">
                          <div class="name">{{ $t('giftcode.discount') }}:</div>
                          <div class="result">
                            <div>
                              {{
                                checkCode.gift_value +
                                ' ' +
                                (checkCode.gift_mode == 'percentage'
                                  ? '%'
                                  : checkCode.gift_mode)
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-skeleton-wrapper>
                </div>
                <!--end: Wizard Step 3-->

                <!--begin: Wizard Step 4-->
                <div class="pb-5" data-wizard-type="step-content">
                  <h4 class="mb-10 font-weight-bold text-dark">
                    {{ $t('detail.stash.checkoutYourOrderAndConfirm') }}
                  </h4>
                  <div class="row">
                    <div class="col-md-9">
                      <div class="border-bottom mb-5 pb-5">
                        <div class="font-weight-bolder mb-3">
                          {{ $t('detail.stash.stashInformation') }}:
                        </div>
                        <div class="line-height-md">
                          {{ step1.stashName }}
                          <p v-if="step1.stashDescription" class="text-muted">
                            {{ step1.stashDescription }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="border-bottom mb-5 pb-5"
                        v-if="step2.username && step2.password"
                      >
                        <div class="font-weight-bolder mb-3">
                          {{ $t('detail.stash.userInformation') }}:
                        </div>
                        <div class="line-height-md">
                          <p>{{ step2.username }}</p>
                          <p class="text-muted mt-2">
                            <PasswordLabel :value="step2.password" />
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 align-items-center">
                      <img
                        src="/media/stash/check-icon.png"
                        class="w-100"
                        :alt="$t('detail.stash.confirmation')"
                      />
                    </div>
                  </div>
                  <div>
                    <div class="font-weight-bolder mb-3">
                      {{ $t('detail.stash.setupPackage') }}:
                    </div>
                    <div class="line-height-md">
                      {{ catalogName }}
                    </div>
                  </div>
                  <div class="border-top mt-5 pt-5" v-if="step3.gift_code">
                    <div class="font-weight-bolder mb-3">
                      {{ $t('giftcode.giftcode') }}:
                    </div>
                    <div class="line-height-md">
                      {{ step3.gift_code }}
                      <div
                        class="product-catalog-total-info justify-content-start mt-3"
                        v-if="checkCode && codeIsValid"
                      >
                        <div
                          class="product-catalog-total-info-content w-100 mw-100"
                        >
                          <div class="item">
                            <div class="name">
                              {{ $t('giftcode.product') }}:
                            </div>
                            <div class="result">
                              <div>
                                {{
                                  checkCode.productCatalog &&
                                  checkCode.productCatalog.data
                                    ? checkCode.productCatalog.data.name
                                    : '-'
                                }}
                              </div>
                            </div>
                          </div>
                          <div class="item">
                            <div class="name">
                              {{ $t('giftcode.discount') }}:
                            </div>
                            <div class="result">
                              <div>
                                {{
                                  checkCode.gift_value +
                                  ' ' +
                                  (checkCode.gift_mode == 'percentage'
                                    ? '%'
                                    : checkCode.gift_mode)
                                }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--end: Wizard Step 4-->
                <div class="d-flex justify-content-between border-top pt-10">
                  <b-skeleton-wrapper :loading="loading">
                    <template #loading>
                      <b-card style="min-width: 500px">
                        <b-skeleton width="85%"></b-skeleton>
                        <b-skeleton width="55%"></b-skeleton>
                        <b-skeleton width="70%"></b-skeleton>
                      </b-card>
                    </template>
                    <div class="mr-2">
                      <b-button
                        variant="light-primary"
                        class="px-9 py-4"
                        data-wizard-type="action-prev"
                      >
                        {{ $t('global.previous') }}
                      </b-button>
                    </div>
                    <div>
                      <b-button
                        v-on:click="submit"
                        variant="primary"
                        class="px-9 py-4"
                        data-wizard-type="action-submit"
                        ref="submitButton"
                      >
                        {{ $t('global.save') }}
                      </b-button>
                      <b-button
                        v-on:click="nextStep"
                        variant="primary"
                        class="px-9 py-4"
                        data-wizard-type="action-next"
                      >
                        {{ $t('global.nextStep') }}
                      </b-button>
                    </div>
                  </b-skeleton-wrapper>
                </div>
                <!--end: Wizard Actions -->
              </form>
            </div>
            <!--end: Wizard-->
          </div>
        </div>
        <!--end: Wizard Body -->
      </div>
      <!--end: Wizard-->
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-2.scss';
</style>

<script>
import ApiService from '@/core/services/api.service'
import KTUtil from '@/assets/js/components/util'
import KTWizard from '@/assets/js/components/wizard'
import { SET_BREADCRUMB } from '@/core/services/store/breadcrumbs.module'
import { SET_CUSTOMHEADERPARAMS } from '@/core/services/store/customsubheader.module'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'StashWizard',
  mixins: [validationMixin],
  data() {
    return {
      loading: false,
      loadingCatalog: false,
      serviceProduct: '',
      catalogList: [],
      checkCode: '',
      codeIsValid: undefined,
      loadingGiftCode: false,
      userNameExist: false,
      _wizard: '',
      step1: {
        stashName: '',
        stashDescription: '',
      },
      step2: {
        username: '',
        password: '',
      },
      step3: {
        productCatalogId: '',
        gift_code: '',
      },
    }
  },
  validations: {
    step1: {
      stashName: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(250),
      },
      stashDescription: {
        minLength: minLength(10),
        maxLength: maxLength(255),
      },
    },
    step2: {
      username: {
        required,
        minLength: minLength(3),
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'global.stash',
        route: '/services/stash',
      },
    ])
    this.$store.dispatch(SET_CUSTOMHEADERPARAMS, {
      menuList: [
        {
          title: 'global.services',
        },
        {
          title: 'global.stash',
          route: '/services/stash',
        },
        {
          title: 'detail.stash.wizard',
          route: '/services/stash/wizard',
        },
      ],
      showSearch: false,
      showDetailButton: false,
      externalButtonUrl: 'https://stash.plusclouds.com',
      externalButtonText: 'detail.stash.goToStash',
    })

    // Initialize form wizard
    this._wizard = new KTWizard('kt_wizard_v2', {
      startStep: 1, // initial active step number
      clickableSteps: true, // allow step clicking
    })

    // Validation before going to next page
    // _wizard.on('beforeNext', function (/*wizardObj*/) {
    // validate the form and use below function to stop the wizard's step
    // _wizard.stop()
    // })

    // Change event
    this._wizard.on('change', function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop()
      }, 500)
    })
  },
  created() {
    this.getStashService()
  },
  computed: {
    catalogName() {
      if (this.step3.productCatalogId)
        return this.catalogList && this.catalogList.length > 0
          ? this.catalogList.find((f) => f.id == this.step3.productCatalogId)
              .name
          : ''
      else return ''
    },
    validateStashName() {
      if (this.step1.stashName) {
        if (this.step1.stashName.length < 5)
          return this.$t('errors.minLenght').replace('{0}', 5)
        else if (this.step1.stashName.length > 250)
          return this.$t('errors.maxLenght').replace('{0}', 250)
      } else return this.$t('errors.notEmpty')
    },
    validateStashDescription() {
      if (this.step1.stashDescription) {
        if (this.step1.stashName.length < 10)
          return this.$t('errors.minLenght').replace('{0}', 10)
        else if (this.step1.stashName.length > 255)
          return this.$t('errors.maxLenght').replace('{0}', 255)
      }

      return ''
    },
    validateUsername() {
      if (this.step2.username) {
        if (this.step2.username.length < 3)
          return this.$t('errors.minLenght').replace('{0}', 3)
        else if (this.userNameExist == true)
          return this.$t('detail.stash.chooseAnotherUsername')
      } else return this.$t('errors.notEmpty')
    },
    validatePassword() {
      if (this.step2.password) {
        if (this.step2.password.length < 3)
          return this.$t('errors.minLenght').replace('{0}', 3)
      } else return this.$t('errors.notEmpty')
    },
    stateUsername() {
      if (this.userNameExist == true) return false

      return this.validateStep2('username')
    },
  },
  methods: {
    getStashService() {
      ApiService.get(`stash/services`)
        .then(({ data }) => {
          if (data && data.data && data.data.length > 0) {
            this.serviceProduct = data.data[0]
            this.getProductCatalogs()
          }
        })
        .catch((err) => {})
    },
    // Product catalog begin
    getProductCatalogs() {
      if (this.serviceProduct.product_id) {
        this.getProductCatalogList()
          .then((res) => {
            this.setProductCatalogList(res)
          })
          .catch(() => {
            this.catalogList = []
          })
      } else this.catalogList = []
    },
    getProductCatalogList() {
      this.loadingCatalog = true
      return new Promise((resolve, reject) => {
        ApiService.get(
          `marketplace/${this.serviceProduct.product_id}/catalogs?page=1&start=0&limit=25&position=id|desc`
        )
          .then(({ data }) => {
            resolve(data)
            this.loadingCatalog = false
          })
          .catch((err) => {
            reject(err)
            this.loadingCatalog = false
          })
      })
    },
    setProductCatalogList(res) {
      if (res && res.data && res.data.length > 0) {
        this.catalogList = res.data
        if (res.data.length == 1)
          this.step3.productCatalogId = this.catalogList[0].id
      }
    },
    // Product catalog end
    checkEnteredCode() {
      if (this.step3.gift_code) {
        this.loadingGiftCode = true
        this.checkCode = ''
        this.codeIsValid = undefined
        ApiService.get(
          `/core/gift-codes/code-exists?code=${this.step3.gift_code}&include=productCatalog`
        )
          .then(({ data }) => {
            this.loadingGiftCode = false
            if (data.data.is_used) {
              this.checkCode = data.data
              this.codeIsValid = false
            } else {
              this.checkCode = data.data
              this.codeIsValid = true
            }
          })
          .catch((data) => {
            this.$generateToast(
              this,
              'danger',
              this.$t('giftcode.notFound'),
              true
            )
            this.loadingGiftCode = false
            this.codeIsValid = false
          })
      } else {
        this.codeIsValid = false
      }
    },
    validateStep1(name) {
      const { $dirty, $error } = this.$v.step1[name]
      return $dirty ? !$error : null
    },
    validateStep2(name) {
      const { $dirty, $error } = this.$v.step2[name]
      return $dirty ? !$error : null
    },
    nextStep(goTo = undefined) {
      this._wizard.stop()

      if (this._wizard.currentStep == 2) {
        this.controlUsername()
      } else {
        if (this._wizard.currentStep == 1) {
          this.$v.step1.$touch()
          if (this.$v.step1.$anyError) {
            return
          }
        } else if (this._wizard.currentStep == 3) {
          if (this.step3.gift_code) this.checkEnteredCode()
        }
        if (goTo == undefined) this._wizard.goNext()
        else this._wizard.goTo(goTo)
        KTUtil.scrollTop()
      }
    },
    submit() {
      this.$v.step1.$touch()
      if (this.$v.step1.$anyError) {
        this._wizard.goTo(1)
        return
      }
      this.$v.step2.$touch()
      if (this.$v.step2.$anyError || this.userNameExist) {
        this._wizard.goTo(2)
        return
      }

      this.loading = true
      let submitButton = this.$refs['submitButton']
      this.$spinnerLoader.addSpinnerLoader(submitButton)

      let params = {
        name: this.step1.stashName,
        description: this.step1.stashDescription,
        stash_service_id: this.serviceProduct.id,
        catalog_id: this.step3.productCatalogId,
        username: this.step2.username,
        password: this.step2.password,
      }
      if (this.codeIsValid == true) {
        params.catalog_id = this.checkCode.product_catalog_id
        params.gift_code = this.step3.gift_code
      }

      ApiService.post(`stash/accounts`, params)
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
          this.checkCode = ''
          this.$v.$reset()
          this.loading = false
          this.$spinnerLoader.removeSpinnerLoader(submitButton)
          setTimeout(() => {
            this.$router.push('/services/stash')
          }, 400)
          // this.saveStashUser(data.data.id)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$spinnerLoader.removeSpinnerLoader(submitButton)
          this.loading = false
        })
    },
    controlUsername() {
      if (this.step2.username) {
        ApiService.get(`stash/user/exists?username=${this.step2.username}`)
          .then(({ data }) => {
            this.userNameExist = data.exists
          })
          .catch((err) => {
            this.userNameExist = true
          })
          .finally(() => {
            this.$v.step2.$touch()
            if (this.$v.step2.$anyError || this.userNameExist) {
              return
            } else {
              this._wizard.goNext()
              KTUtil.scrollTop()
            }
          })
      } else {
        this.$v.step2.$touch()
        if (this.$v.step2.$anyError || this.userNameExist) {
          return
        } else {
          this._wizard.goNext()
          KTUtil.scrollTop()
        }
      }
    },
    removeCode() {
      this.step3.gift_code = ''
      this.checkCode = ''
    },
  },
}
</script>

<style lang="scss">
.wizard-body {
  background-image: url('/media/stash/card-bg.png');
  background-position: bottom left;
}
.product-catalog-total-info {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &-content {
    width: 100%;
    max-width: 250px;
    padding: 20px;
    border: 1px solid #e5eaee;
    border-radius: 6px;

    .item {
      display: flex;

      .name {
        width: 100%;
        max-width: 100px;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        color: #b5b5c3;
      }

      .result {
        flex: 1;
        font-weight: 600;
        font-size: 14px;
        line-height: 21px;
        text-align: right;
        color: #464e5f;
      }
    }
  }
}
</style>
